export default "__VITE_PUBLIC_ASSET__59bcc9fd__"